import BlogTwentyFourContainer from "./container/BlogTwentyFourContainer";
export default BlogTwentyFourContainer;
